define([], () => ({dto, isEditable, onEdit}) => {
    return {
        dto,
        get isEditable() { return isEditable(); },
        edit() { onEdit(); }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/additional/models/AdditionalInfo.js
 **/